import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";

import api from "../../api/api";

export default function Clients() {

  const [clients, setClients] = useState([]);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: ""
  });

  useEffect(() => {
    loadClients();
  }, []);

  // =====================================
  // LOAD CLIENTS
  // =====================================

  const loadClients = async () => {

    try {

      const res = await api.get("/billing/clients");

      setClients(res.data);

    } catch (err) {

      console.error("Error loading clients", err);

    }

  };

  // =====================================
  // HANDLE FORM INPUT
  // =====================================

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  // =====================================
  // CREATE CLIENT
  // =====================================

  const createClient = async () => {

    try {

      await api.post("/billing/clients", form);

      setForm({
        name: "",
        email: "",
        phone: "",
        address: ""
      });

      loadClients();

    } catch (err) {

      console.error("Client create error", err);

    }

  };

  return (

    <Box p={4}>

      <Typography variant="h5" mb={3}>
        Clients
      </Typography>

      {/* ===================================== */}
      {/* CLIENT CREATE FORM */}
      {/* ===================================== */}

      <Card sx={{ mb: 4 }}>

        <CardContent>

          <Grid container spacing={2}>

            <Grid item xs={12} md={3}>
              <TextField
                label="Client Name"
                name="name"
                fullWidth
                value={form.name}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                label="Email"
                name="email"
                fullWidth
                value={form.email}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <TextField
                label="Phone"
                name="phone"
                fullWidth
                value={form.phone}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                label="Address"
                name="address"
                fullWidth
                value={form.address}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={1}>
              <Button
                variant="contained"
                onClick={createClient}
                fullWidth
                sx={{ height: "56px" }}
              >
                Add
              </Button>
            </Grid>

          </Grid>

        </CardContent>

      </Card>

      {/* ===================================== */}
      {/* CLIENT TABLE */}
      {/* ===================================== */}

      <Card>

        <CardContent>

          <Table>

            <TableHead>

              <TableRow>

                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Address</TableCell>

              </TableRow>

            </TableHead>

            <TableBody>

              {clients.map((c) => (

                <TableRow key={c.id}>

                  <TableCell>{c.name}</TableCell>
                  <TableCell>{c.email}</TableCell>
                  <TableCell>{c.phone}</TableCell>
                  <TableCell>{c.address}</TableCell>

                </TableRow>

              ))}

            </TableBody>

          </Table>

        </CardContent>

      </Card>

    </Box>

  );
}